<template>
  <g id="head/bang2">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M760.709 341.685C700.704 301.882 580.49 306.205 514.436 330.591C449.984 351.074 427.419 408.15 416.717 469.812C403.71 539.116 405.458 639.019 498.994 637.81C512.145 644.183 526.713 646.946 540.319 652.224C558.942 658.676 577.201 666.167 596.098 671.818C633.317 683.83 674.734 682.784 710.04 665.207C729.546 655.765 737.62 641.06 750.376 625.391C787.488 579.806 806.162 514.568 804.489 456.604C801.555 415.789 794.818 368.541 760.709 341.685Z"
      :fill="skinColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M836.642 509.695C830.485 471.395 828.778 432.445 820.715 394.445C813.131 358.686 798.951 324.895 774.174 297.635C752.001 273.245 723.331 255.335 692.556 243.985C632.603 221.875 563.649 226.875 505.651 252.686C451.366 276.835 408.068 321.515 382.831 375.135C366.436 409.975 358.193 447.015 354.531 485.245C350.469 527.715 350.03 570.625 348.374 613.245C348.174 618.505 347.885 623.765 347.815 629.026C347.735 634.785 350.06 639.835 351.956 645.195C352.086 645.575 352.276 645.936 352.505 646.276C351.078 646.455 349.651 646.665 348.224 646.895C346.628 647.145 346.697 649.745 348.224 650.055C361.147 652.695 374.429 653.065 387.571 653.715C401.192 654.395 414.833 654.766 428.474 655.225C441.776 655.675 455.078 656.125 468.38 656.575C475.365 656.815 482.351 657.055 489.336 657.285C492.659 657.395 495.982 657.516 499.315 657.625C500.971 657.686 502.638 657.734 504.294 657.795C505.641 657.835 507.837 658.695 507.976 657.705C508.226 657.856 508.495 657.984 508.785 658.075C509.104 658.245 509.413 658.445 509.713 658.665C511.339 659.785 513.804 659.645 515.451 658.665C515.6 658.575 515.76 658.475 515.92 658.375C517.147 657.645 518.005 656.585 518.484 655.385C525.31 663.645 537.394 654.365 530.409 645.625C526.657 640.925 489.336 525.695 504.783 437.915L566.732 429.695C578.058 428.545 599.134 426.255 599.134 426.255C599.134 426.255 604.293 409.385 605.77 403.955C605.879 403.555 605.989 403.145 606.109 402.745C607.586 405.356 609.073 407.955 610.57 410.555L618.213 426.125C618.213 426.125 731.035 424.235 758.696 424.415C759.165 424.415 761.391 458.115 760.383 472.955C758.347 502.755 756.182 532.535 753.168 562.255C751.245 581.286 746.608 599.948 739.702 617.488C728.792 645.195 697.117 671.531 666.232 671.531C647.007 671.531 603.564 655.927 597.238 652.776C590.911 649.625 587.141 658.225 592.907 661.665C604.586 668.634 636.78 683.415 666.232 683.415C709.004 683.415 741.293 642.745 745.255 636.915C784.202 634.776 824.038 635.765 862.936 639.635C866.199 639.955 869.013 636.015 867.965 633.005C853.995 592.936 843.367 551.606 836.642 509.695Z"
      :fill="hairColor"
    />
  </g>
</template>

<script>
export default {
  name: 'HeadBang2',
  props: {
    skinColor: {
      type: String,
      default () {
        return 'white'
      }
    },
    hairColor: {
      type: String,
      default () {
        return 'white'
      }
    }
  }
}
</script>
